import { useAuth } from "../contexts"
import { useUserProfile } from "../portal-apps"

export const useIsSuperuser = (): boolean => {
	const { user } = useAuth()
	const [profile] = useUserProfile(user?.id)

	return profile?.isCustomer === true && profile?.isCustomerSuperuser === true
}
